<template>  
  <div @click="$router.push({ name: 'shop', params: { id: id }})">
    <md-card>
      <md-card-media-cover>
        <div class="overlay"></div>
        <md-card-media md-ratio="16:9">
          <img :src="`${image}normal`">
          <!--<img src="/static/card-placeholder.png" alt="">-->
        </md-card-media>
        <md-card-area>
          <md-card-header class="text-align-left">
            <span class="md-subhead">{{category}}</span>
            <span class="md-title">{{name}}</span>
          </md-card-header>
          <md-card-content>          
              <div class="md-layout md-gutter">
                <div class="md-layout-item text-align-left">
                  <div class="label label--success" v-if="isOpen">Aperto</div>
                  <div class="label label--danger" v-else>Chiuso</div>
                </div>
                <div class="md-layout-item text-align-right">
                  {{city}}
                </div>
              </div>
          </md-card-content>        
        </md-card-area>
      </md-card-media-cover>
    </md-card>
  </div>
</template>

<script>
export default {
  name: 'Card',
  data() {
    return {
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },      
    city: {
      type: String,
      default: ''
    }, 
    image: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },         
  },
  mounted() {
    
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/modules/common/components/card/Card.vue